import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import PageHeader from '../components/PageHeader'
import PageBodyContainer from '../components/PageBodyContainer'
import FlexContainer from 'core-system/FlexContainer'
import PrimaryButton from 'core-system/Button/PrimaryButton'
import { AppState } from 'redux/config/store'
import { employerActions } from 'redux/employer/employerSlice'
import { AutoInviteSetting } from 'redux/employer/employerTypes'
import { AutoEnrollSection, autoEnrollActions } from 'features/AutoEnroll'
import { AutoInviteSection, autoInviteActions } from 'features/AutoInvite'
import { ApiRosterSyncSection } from 'features/ApiRosterSync'

interface SyncSettingsViewProps {
  activeTab: number
  setActiveTab: (tab: number) => void
  tabs: { label: string; value: number }[]
}

const SyncSettingsView = ({
  activeTab,
  setActiveTab,
  tabs,
}: SyncSettingsViewProps) => {
  const dispatch = useDispatch()
  const employer = useSelector((state: AppState) => state.employer.profile)

  const [autoInviteSetting, setAutoInviteSetting] =
    useState<AutoInviteSetting>('DISABLED')

  // Initialize state from employer profile
  useEffect(() => {
    if (employer) {
      setAutoInviteSetting(employer.autoInviteSetting)
    }
  }, [employer])

  /** Saves all sync settings to the backend (auto-invite + auto-enroll rules). */
  const handleSaveSettings = () => {
    dispatch(
      employerActions.updateAutoInviteSettings({
        autoInviteSetting,
      })
    )
    dispatch(autoInviteActions.saveAutoInviteRule())
    dispatch(autoEnrollActions.saveAutoEnrollRules())
  }

  const autoEnrollSaveLoading = useSelector(
    (state: AppState) => state.autoEnroll.saveLoading
  )
  const autoInviteSaveLoading = useSelector(
    (state: AppState) => state.autoInvite.saveLoading
  )
  const saveLoading = autoEnrollSaveLoading || autoInviteSaveLoading

  return (
    <>
      <PageHeader
        activeTab={activeTab}
        setActiveTab={setActiveTab}
        tabs={tabs}
      />
      <PageBodyContainer>
        <ApiRosterSyncSection />
        <AutoInviteSection
          autoInviteSetting={autoInviteSetting}
          onAutoInviteSettingChange={setAutoInviteSetting}
        />
        <AutoEnrollSection />
        <FlexContainer marginTop='2rem'>
          <PrimaryButton onClick={handleSaveSettings} isLoading={saveLoading}>
            Save Settings
          </PrimaryButton>
        </FlexContainer>
      </PageBodyContainer>
    </>
  )
}

export default React.memo(SyncSettingsView)
